import { FadeUp } from "./Reveal";
import { NoteEyebrow } from "./NoteEyebrow";
import { EmSwash } from "./EmSwash";
import { MANIFESTO, IMAGES } from "../data/content";

/**
 * ManifestoBeats — one statement (chapter 01, verbatim) and a single row of
 * three short beats (chapters 02 and 03 verbatim, plus the 501(c)(3) line).
 * Replaced the three full-height magazine spreads (audit item H5). Beats are
 * unordered: a colour dash marks each, no numerals.
 */
const BEATS = [
  { title: `${MANIFESTO[1].title} ${MANIFESTO[1].italic}`, body: MANIFESTO[1].body, accent: "bg-grass" },
  { title: `${MANIFESTO[2].title} ${MANIFESTO[2].italic}`, body: MANIFESTO[2].body, accent: "bg-blossom" },
  { title: "Every gift is tax-deductible.", body: "My Rich Aunt is a registered 501(c)(3). Gifts are made to My Rich Aunt, which awards every grant.", accent: "bg-yellow" },
];

export const ManifestoBeats = () => {
  const lead = MANIFESTO[0];
  return (
    <section id="manifesto" className="mx-auto max-w-7xl px-6 py-20 lg:px-8 lg:py-32" data-testid="manifesto-beats">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-7">
          <FadeUp tier="sm"><NoteEyebrow accent="bg-cobalt">the manifesto</NoteEyebrow></FadeUp>
          <FadeUp>
            <h2 className="mt-5 font-serif text-3xl lg:text-[3.5rem] leading-[1.02] tracking-tight text-ink">
              {lead.title} <EmSwash color={lead.accent}>{lead.italic}</EmSwash>
            </h2>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-olive">{lead.body}</p>
          </FadeUp>
        </div>
        <FadeUp className="lg:col-span-4 lg:col-start-9">
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl">
            <img src={IMAGES.handsHeld} alt="An aunt and her niece holding hands in the sun" className="h-full w-full object-cover" loading="lazy" />
          </div>
        </FadeUp>
      </div>

      <FadeUp>
        <ul className="mt-16 grid grid-cols-1 gap-10 border-t border-ink/10 pt-12 md:grid-cols-3 md:gap-6" data-testid="manifesto-beats-row">
          {BEATS.map((b) => (
            <li key={b.title} className="max-w-sm">
              <span className={`block h-2 w-8 rounded-full ${b.accent}`} aria-hidden="true" />
              <h3 className="mt-4 font-serif text-3xl leading-tight text-ink">{b.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-olive">{b.body}</p>
            </li>
          ))}
        </ul>
      </FadeUp>
    </section>
  );
};
